import React from 'react';
import { connect } from 'react-redux';
import { hooks } from '@lifesize/clients.sdk';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';
import {
  conferenceRemoteModerationSelectors,
  contactSelectors,
  currentUserSelectors,
  featureSelectors,
  remoteModeratorActions,
  directoryActions
} from '@lifesize/nucleus';
import actions, { loadInitialRooms } from 'actions/Contact';
import { openFullScreenModal } from 'actions/FullScreenModal';
import { endRouteLoading } from 'actions/SideNav';
import RoomSystems from 'components/RoomSystems/RoomSystems';
import { SCHEDULE_MODAL } from 'constants/ScheduleModal';
import { CONTACT_MODAL } from 'constants/ContactModal';
import { WEB_RemoteModerators } from 'constants/FeatureFlags';
import { selectPreviousPath } from 'selectors/auth';

const isRemoteModerationIsActiveForThisMeeting = (rmIsActive, rmCurrentExt, meetingExt) => {
  return rmIsActive && rmCurrentExt === meetingExt;
};

function mapDispatchToProps(dispatch) {
  return {
    fetchNext: () => dispatch(directoryActions.fetchNext(['ROOM'])),
    endRouteLoading: () => dispatch(endRouteLoading()),
    handleAudioCall: (contact) => dispatch(actions.startAudioCall(contact)),
    handleCreateContact: () => dispatch(openFullScreenModal(CONTACT_MODAL, { isCreate: true })),
    handleRemoteModerate: async (ext, swap = false) => {
      if (swap || !ext) {
        await dispatch(remoteModeratorActions.leaveCurrent());
      }
      if (ext) {
        dispatch(remoteModeratorActions.join(ext));
      }
    },
    handleSchedule: (id) => dispatch(openFullScreenModal(SCHEDULE_MODAL, id)),
    handleVideoCall: (contact) => dispatch(actions.startVideoCall(contact)),
    loadInitialRooms: () => dispatch(loadInitialRooms())
  };
}
const mapStateToProps = (state, ownProps) => {
  const remoteModerationEnabled = featureSelectors.getFeatureFlag(state)(WEB_RemoteModerators);
  const selectedContact = contactSelectors.getContactByUuidGenerator(state)(
    _get(state, 'app.contacts.selectedContact.uuid')
  );
  const selectedContactExt = _get(selectedContact, 'dialString') || _get(selectedContact, 'extension');
  const remoteModerationIsActive = ownProps.isRemoteModerationActive;
  const remoteModerationCurrentExt = ownProps.isRemoteModerationActive;
  const remoteModerationIsActiveForThisMeeting = isRemoteModerationIsActiveForThisMeeting(
    remoteModerationIsActive,
    remoteModerationCurrentExt,
    selectedContactExt
  );
  const userCanRemoteModerate = (contact) =>
    remoteModerationEnabled &&
    conferenceRemoteModerationSelectors.selectCanCurrentUserRemoteModerate(state, {
      extension: _get(contact, 'dialString') || _get(contact, 'extension')
    });
  return {
    contacts: contactSelectors.roomSystemsSelector(state),
    currentUserId: currentUserSelectors.getUserUUID(state),
    getSelectedContact: (uuid) => contactSelectors.getContactByUuidGenerator(state)(uuid),
    loading: _get(state, 'app.contacts.loadingRooms'),
    previousPath: selectPreviousPath(state),
    remoteModerationIsActive,
    remoteModerationIsActiveForThisMeeting,
    scrollToSelected: state.app.contacts.scrollToSelected,
    userCanRemoteModerate
  };
};

const ConnectedComponent = withRouter(connect(mapStateToProps, mapDispatchToProps)(RoomSystems));

const FunctionalWrapper = (props) => {
  const isRemoteModerationActive = hooks.useIsRemoteModerationActive();
  const remoteModerationExtension = hooks.useRemoteModerationExtension();
  return (
    <ConnectedComponent
      {...props}
      remoteModerationExtension={remoteModerationExtension}
      isRemoteModerationActive={isRemoteModerationActive}
    />
  );
};

export { ConnectedComponent as RoomSystemsContainer };
export default FunctionalWrapper;
